module.exports = __webpack_public_path__ + "42a9417fae7b8b2dd6cfba422a918215.MP3";